<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/newJoineeicon.svg" class="h-20px w-20px rounded mr-2" />  {{'NewJoiners' | localize}}
        </h5>

    </div>

    <div class="card-body p-3">
        <!--Shimmer Section Code-->
        <div *ngIf="isLoaded && isempty">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-15">
                    <img src="../../../../assets/common/images/new-dashboard/new-joinee-empty-ui.png" class="h-165px w-140px ml-4" />
                    <h6 class="text-muted text-center mt-4 ml-2">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>

        <div *ngIf="!isLoaded && isempty" class="pt-2">
            <div class="col-md-12">
                <div class="card  h-55px mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card  h-55px mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card  h-55px mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card h-55px mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>
        </div>


        <!--New Joinees Code Section-->
        <div *ngIf="isLoaded && !isempty" class="overflow">
            <div *ngFor="let userInfo of newJoineInfo; let i= index " class="row mt-3">
                <div class="col-md-12">
                    <ul class="detailsdepart_ul d-flex">
                        <li class="icon_li">
                            <img [src]="userInfo.userImage" class="h-50px w-50px border border-light rounded p-1" id="profimgsize" />
                        </li>
                        <li class="content_li">
                            <span class="font-weight-bolder" pTooltip="{{userInfo.userName}}" [tooltipDisabled]="DisableTooltip(userInfo.userName,16)" tooltipPosition="bottom">
                                {{userInfo.userName | titlecase | slice:0:16 }}{{ userInfo.userName.length > 16 ? '...' : ''}}<i style=" font-size: 8px; color: #243A5E;"> {{'joinedons' | localize}} {{userInfo.userJoinDate | date : 'MMM d, y'}}</i>
                            </span>
                            <br />
                            <!-- <small class="text-muted">
                                {{userInfo.usersRole?.toString().replace(',' , ', ')}}
                            </small> -->

                            <small class="text-left font10" pTooltip="{{ userInfo?.usersRole?.toString().replace(',' , ', ') }}"
                                [tooltipDisabled]="DisableTooltip(userInfo?.usersRole?.toString().replace(',' , ', '),15)" tooltipPosition="bottom">
                                {{ (userInfo?.usersRole?.toString().replace(',' , ', ')).slice(0, 15) }}{{
                                userInfo?.usersRole?.toString().replace(',' , ', ').length > 15 ? '...' : '' }}
                            </small>









                            <br />
                            <small>
                                <b class="text-muted" pTooltip="{{userInfo.email}}" [tooltipDisabled]="DisableTooltip(userInfo.email,25)" tooltipPosition="bottom">
                                    {{userInfo.email | slice:0:25 }}{{ userInfo.email.length > 25 ? '...' : ''}}
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>

        </div>

    </div>


</div>
